export default {"src":"/_next/static/media/menu-close-btn.3ff98d7a.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};